import { render, staticRenderFns } from "./ProposalCheckList.vue?vue&type=template&id=baa8b290&"
import script from "./ProposalCheckList.vue?vue&type=script&lang=js&"
export * from "./ProposalCheckList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports